export default {
  invalid_code_format_warning: "A code was found, but it was in an invalid format.",
  invalid_code_value_warning: "A code was found, but its read value was not valid.",
  missing_browser_camera_permission_warning:
    "Please either allow camera or reset your browser's camera permission to continue.",
  missing_camera_permission_warning:
    "The application needs to use your camera, but camera permission has not been granted.",
  missing_camera_warning: "No camera has been found on the current device.",
  nfc_warning: "NFC is not available or is disabled",
}
